module.exports = __webpack_public_path__ + "img/a-s-3.bed5aa0f.jpg";